/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import lang from 'quasar/lang/en-us';
import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDate from 'quasar/src/components/date/QDate.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QTime from 'quasar/src/components/time/QTime.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPageScroller from 'quasar/src/components/page-scroller/QPageScroller.js';import QPage from 'quasar/src/components/page/QPage.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QItem from 'quasar/src/components/item/QItem.js';import QInput from 'quasar/src/components/input/QInput.js';import QField from 'quasar/src/components/field/QField.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCard from 'quasar/src/components/card/QCard.js';import QChip from 'quasar/src/components/chip/QChip.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QTimeline from 'quasar/src/components/timeline/QTimeline.js';import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QRange from 'quasar/src/components/range/QRange.js';import QKnob from 'quasar/src/components/knob/QKnob.js';import QTree from 'quasar/src/components/tree/QTree.js';import QForm from 'quasar/src/components/form/QForm.js';import QFab from 'quasar/src/components/fab/QFab.js';import QFabAction from 'quasar/src/components/fab/QFabAction.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QTable from 'quasar/src/components/table/QTable.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QTd from 'quasar/src/components/table/QTd.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QTr from 'quasar/src/components/table/QTr.js';import QTh from 'quasar/src/components/table/QTh.js';import QImg from 'quasar/src/components/img/QImg.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QEditor from 'quasar/src/components/editor/QEditor.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QRating from 'quasar/src/components/rating/QRating.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QColor from 'quasar/src/components/color/QColor.js';import QFile from 'quasar/src/components/file/QFile.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import GoBack from 'quasar/src/directives/GoBack.js';import Intersection from 'quasar/src/directives/Intersection.js';import Morph from 'quasar/src/directives/Morph.js';import TouchPan from 'quasar/src/directives/TouchPan.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import BottomSheet from 'quasar/src/plugins/BottomSheet.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import Loading from 'quasar/src/plugins/Loading.js';;
Vue.use(Quasar, {
  config: {
    "ripple": {
      "early": true
    },
    "cordova": {
      "backButtonExit": true,
      "iosStatusBarPadding": true
    }
  },
  lang: lang,
  components: {
    QLayout: QLayout,
    QHeader: QHeader,
    QDate: QDate,
    QPopupProxy: QPopupProxy,
    QTime: QTime,
    QFooter: QFooter,
    QDrawer: QDrawer,
    QPageContainer: QPageContainer,
    QPageScroller: QPageScroller,
    QPage: QPage,
    QStep: QStep,
    QStepper: QStepper,
    QStepperNavigation: QStepperNavigation,
    QToolbar: QToolbar,
    QToolbarTitle: QToolbarTitle,
    QBtn: QBtn,
    QBtnGroup: QBtnGroup,
    QIcon: QIcon,
    QList: QList,
    QDialog: QDialog,
    QItem: QItem,
    QInput: QInput,
    QField: QField,
    QOptionGroup: QOptionGroup,
    QCardActions: QCardActions,
    QCheckbox: QCheckbox,
    QCardSection: QCardSection,
    QCard: QCard,
    QChip: QChip,
    QAvatar: QAvatar,
    QTimeline: QTimeline,
    QTimelineEntry: QTimelineEntry,
    QPageSticky: QPageSticky,
    QItemSection: QItemSection,
    QItemLabel: QItemLabel,
    QSpace: QSpace,
    QBadge: QBadge,
    QRange: QRange,
    QKnob: QKnob,
    QTree: QTree,
    QForm: QForm,
    QFab: QFab,
    QFabAction: QFabAction,
    QSeparator: QSeparator,
    QToggle: QToggle,
    QRadio: QRadio,
    QTable: QTable,
    QBtnToggle: QBtnToggle,
    QTd: QTd,
    QMenu: QMenu,
    QTr: QTr,
    QTh: QTh,
    QImg: QImg,
    QExpansionItem: QExpansionItem,
    QCircularProgress: QCircularProgress,
    QCarousel: QCarousel,
    QCarouselSlide: QCarouselSlide,
    QCarouselControl: QCarouselControl,
    QVirtualScroll: QVirtualScroll,
    QMarkupTable: QMarkupTable,
    QEditor: QEditor,
    QSelect: QSelect,
    QRating: QRating,
    QScrollArea: QScrollArea,
    QBanner: QBanner,
    QSlideTransition: QSlideTransition,
    QSlider: QSlider,
    QTabs: QTabs,
    QTab: QTab,
    QTooltip: QTooltip,
    QColor: QColor,
    QFile: QFile,
    QTabPanel: QTabPanel,
    QTabPanels: QTabPanels,
    QBtnDropdown: QBtnDropdown,
    QLinearProgress: QLinearProgress,
    QPopupEdit: QPopupEdit,
    QSpinnerDots: QSpinnerDots
  },
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup,
    GoBack: GoBack,
    Intersection: Intersection,
    Morph: Morph,
    TouchPan: TouchPan
  },
  plugins: {
    Notify: Notify,
    Dialog: Dialog,
    BottomSheet: BottomSheet,
    LocalStorage: LocalStorage,
    Loading: Loading
  }
});